const URL_REGEX = /(https?:\/\/[^\s<>"']+|www\.[^\s<>"']+)/gi;
const TRAILING_PUNCTUATION_REGEX = /[\])},.!?;:]+$/;

const HTML_ESCAPE_MAP = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
};

function escapeHtml(value) {
    return String(value === null || value === undefined ? '' : value)
        .replace(/[&<>"']/g, char => HTML_ESCAPE_MAP[char]);
}

function normalizeHref(url) {
    return /^https?:\/\//i.test(url) ? url : `https://${url}`;
}

function splitTrailingPunctuation(value) {
    const text = String(value || '');
    const match = text.match(TRAILING_PUNCTUATION_REGEX);

    if (!match) {
        return {
            url: text,
            trailing: ''
        };
    }

    return {
        url: text.slice(0, -match[0].length),
        trailing: match[0]
    };
}

export function linkifyText(text) {
    const source = String(text === null || text === undefined ? '' : text);
    let result = '';
    let lastIndex = 0;

    source.replace(URL_REGEX, (match, url, offset) => {
        const parts = splitTrailingPunctuation(url);

        result += escapeHtml(source.slice(lastIndex, offset));

        if (!parts.url) {
            result += escapeHtml(match);
        } else {
            const href = normalizeHref(parts.url);
            result += `<a href="${escapeHtml(href)}" target="_blank" rel="noopener noreferrer">${escapeHtml(parts.url)}</a>`;
            result += escapeHtml(parts.trailing);
        }

        lastIndex = offset + match.length;
        return match;
    });

    result += escapeHtml(source.slice(lastIndex));
    return result;
}

export default linkifyText;
